import { getApiActionCreator } from 'helpers/actionHelper';
import { actionTypes } from './constants';

// Status update action creators (used by sagas to emit LOADING / SUCCESS / ERROR)
export const getFleetBarCharts = getApiActionCreator(actionTypes.GET_BAR_CHARTS);
export const getFleetStatisticsAssets = getApiActionCreator(actionTypes.GET_STATISTICS_ASSETS);
export const getFleetStatisticsAssetsGroup = getApiActionCreator(actionTypes.GET_STATISTICS_ASSETSGROUP);
export const getFleetStatisticsPowertrain = getApiActionCreator(actionTypes.GET_STATISTICS_POWERTRAIN);
export const getFleetAnalyticsAggregatedAssets = getApiActionCreator(actionTypes.GET_ANALYTICS_AGGREGATED_ASSET);
export const getFleetAnalyticsAggregatedAssetsGroup = getApiActionCreator(actionTypes.GET_ANALYTICS_AGGREGATED_ASSETGROUP);
export const getFleetAnalyticsAggregatedPowertrain = getApiActionCreator(actionTypes.GET_ANALYTICS_AGGREGATED_POWERTRAIN);

// Request action creators (trigger fleetOverviewSagas)
export const getFleetBarChartsAction = (payload, isLSU, isREC) => ({
    type: actionTypes.GET_BAR_CHARTS_REQUEST,
    payload,
    isLSU,
    isREC
});

export const getFleetStatisticsAssetsAction = (tab, params) => ({
    type: actionTypes.GET_STATISTICS_ASSETS_REQUEST,
    payload: { tab, params }
});

export const getFleetStatisticsAssetsGroupAction = (tab, params) => ({
    type: actionTypes.GET_STATISTICS_ASSETSGROUP_REQUEST,
    payload: { tab, params }
});

export const getFleetStatisticsPowertrainAction = (tab, params) => ({
    type: actionTypes.GET_STATISTICS_POWERTRAIN_REQUEST,
    payload: { tab, params }
});

export const getFleetAnalyticsAggregatedAssetsAction = (tab, params) => ({
    type: actionTypes.GET_ANALYTICS_AGGREGATED_ASSET_REQUEST,
    payload: { tab, params }
});

export const getFleetAnalyticsAggregatedAssetsGroupAction = (tab, params) => ({
    type: actionTypes.GET_ANALYTICS_AGGREGATED_ASSETGROUP_REQUEST,
    payload: { tab, params }
});

export const getFleetAnalyticsAggregatedPowertrainAction = (tab, params) => ({
    type: actionTypes.GET_ANALYTICS_AGGREGATED_POWERTRAIN_REQUEST,
    payload: { tab, params }
});

// Non-API actions
export const updateFleetOverviewInitialLoad = () => ({
    type: actionTypes.UPDATE_FLEET_OVERVIEW_INITIAL_LOAD
});

export const setExpandedAssetGroup = (data) => ({
    type: actionTypes.SET_EXPANDED_ASSET_GROUP,
    data
});

export const setExpandedPowertrain = (data) => ({
    type: actionTypes.SET_EXPANDED_POWERTRAIN,
    data
});

export const clearFleetOverviewDataAction = () => ({
    type: actionTypes.CLEAR_FLEET_OVERVIEW_DATA
});

export const updateFleetUserTypeAction = (isLSU, isREC) => ({
    type: actionTypes.SET_FLEET_USER_TYPE,
    isLSU,
    isREC
});

export const updateRefreshCacheFlag = (refreshCache, ciamSyncFlag) => ({
    type: actionTypes.UPDATE_REFRESH_CACHE_FLAG,
    refreshCache,
    ciamSyncFlag
});
